import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../../../icons";
import { cn } from "../../../utils";
import Button from "../../Button";
const BannerClose = ({ onClick, className }) => {
    return (_jsx("div", { className: cn("absolute top-0 right-0", className), children: _jsx(Button, { variant: "ghost", size: "sm", className: "text-gray-10", icon: _jsx(Icon, { name: "x", className: "size-4" }), onClick: onClick }) }));
};
export default BannerClose;
